import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";

const doors = [
  { to: "/acting", n: "01", t: "Acting", d: "Film · TV · Documentary", img: "/img/home-acting.jpg", pos: "50% 27%" },
  { to: "/story", n: "02", t: "Story", d: "The Cinematic Odyssey", img: "/img/act1-temple.jpg", pos: "50% 12%" },
  { to: "/activism", n: "03", t: "Activism", d: "Reduce Inequalities Together · Goal 10", img: "/img/home-activism.jpg", pos: "50% 30%" },
];

export const Doorways = () => (
  <section data-testid="home-doorways" className="max-w-[1500px] mx-auto px-5 sm:px-10 py-24 sm:py-32">
    {doors.map((d, i) => (
      <Reveal key={d.to} delay={i * 0.08}>
        <div data-testid={`home-door-${d.to.slice(1)}`}
          className="group relative grid grid-cols-12 items-center gap-4 sm:gap-8 py-8 sm:py-10 border-t border-black/10">
          <Link to={d.to} aria-label={d.t} data-testid={`home-door-${d.to.slice(1)}-link`} className="absolute inset-0 z-0" />
          <span className="col-span-2 sm:col-span-1 text-sm text-stone-500 tracking-widest">{d.n}</span>
          <div className="col-span-10 sm:col-span-6">
            <h2 className="font-display text-4xl sm:text-6xl leading-none group-hover:italic group-hover:text-[var(--gold)] transition-colors duration-500">{d.t}</h2>
            <p className="mt-3 text-sm uppercase tracking-[0.2em] text-stone-500">{d.d}</p>
          </div>
          <div className={`col-span-12 sm:col-span-4 ${d.ratio || "aspect-[16/9]"} overflow-hidden pointer-events-none`}>
            <img src={d.img} alt={d.t} style={{ objectPosition: d.pos || "50% 50%" }} className={`h-full w-full object-cover ${d.ratio ? "scale-[1.03]" : "scale-110"} group-hover:scale-100 transition-transform duration-[1400ms] ease-out`} />
          </div>
          <ArrowUpRight className="hidden sm:block sm:col-span-1 justify-self-end text-[var(--gold)] transition-transform duration-500 group-hover:rotate-45 pointer-events-none" size={28} />
        </div>
      </Reveal>
    ))}
    <div className="border-t border-black/10" />
  </section>
);
